var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClockOrange(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: 560.17499,
    height: 560.17499,
    viewBox: "0 0 22.407 22.407",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 11.188,22.407 C 5,22.407 0,17.407 0,11.219 0,5.031 5,0 11.188,0 c 6.188,0 11.219,5.031 11.219,11.219 0,6.188 -5.031,11.188 -11.219,11.188 z m 0,-19.625 c -4.625,0 -8.375,3.813 -8.375,8.438 0,4.625 3.75,8.375 8.375,8.375 4.625,0 8.438,-3.75 8.438,-8.375 0,-4.625 -3.813,-8.438 -8.438,-8.438 z M 14.219,15.5 10.25,12.594 C 9.969,12.375 9.687,11.906 9.687,11.531 V 5.187 C 9.687,4.843 10,4.562 10.375,4.562 h 1.313 c 0.344,0 0.625,0.281 0.625,0.625 v 5 c 0,0.375 0.281,0.844 0.563,1.063 l 2.906,2.094 c 0.281,0.219 0.344,0.656 0.125,0.938 l -0.781,1.063 c -0.219,0.281 -0.625,0.344 -0.906,0.156 z",
    fill: "#ffa500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockOrange);
export default __webpack_public_path__ + "static/media/clockOrange.d0fc67b5d4545c7a7f6f6de6e52fc761.svg";
export { ForwardRef as ReactComponent };